import { JwtModuleOptions } from "@auth0/angular-jwt";
import { environment } from "src/environments/environment";

/** Key for the access token in LocalStorage. */
export const ACCESS_TOKEN_LS_KEY = "access_token";

export const JWT_MODULE_OPTIONS: JwtModuleOptions = {
	config: {
		tokenGetter: () => localStorage.getItem(ACCESS_TOKEN_LS_KEY),
		allowedDomains: [environment.allowedDomain],
	},
};
